import { apiRoutes } from './apiRoutes.js';
import { authenticatedFetch } from './auth/authSession.js';

export async function fetchCodelyShare(shareId) {
  const normalizedShareId = String(shareId || '').trim();
  if (!normalizedShareId) {
    throw new Error('Codely share id is required.');
  }

  const response = await authenticatedFetch(apiRoutes.codelyShare(normalizedShareId), {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const content = await response.json().catch(() => null);
  if (!response.ok) {
    const message = content?.errorMessage || content?.message || `Codely share request failed with status ${response.status}.`;
    throw new Error(message);
  }
  return content;
}
